// Fer's profiles, shared by the footer and the phone menu.
export const SOCIAL_LINKS = {
  tiktok: 'https://www.tiktok.com/@ferbrambi_',
  youtube: 'https://www.youtube.com/@ferbrambi',
  instagram: 'https://www.instagram.com/ferbrambi_/',
  discord: 'https://discord.com/invite/FF4EVGVm4Y',
  twitch: 'https://www.twitch.tv/ferbrambi_',
};
